// Libs
import React, { Component } from 'react'
import { reduxForm, formValueSelector } from 'redux-form'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components
import MyCasesPageFilterSection from '../MyCasesPageFilterSection'
import SideBar from '../../../../components/SideBar'

// Options
import { uf } from '../../constants'

class MyCasesPageFilter extends Component {
  ifChecked = (preRequisiteSection, value, section) => {
    const { filter, handleReset } = this.props

    if (filter && !_.isEmpty(filter.values)) {
      if (filter.values[preRequisiteSection] && filter.values[preRequisiteSection].indexOf(value) !== -1) {
        return true
      }
      if (filter.values[section]) {
        handleReset(section)
        return false
      }
    }
  }

  render() {
    const { visible, role, companies, lawFirms, createdBy, classifiers, archiveReasons, handleOpen, handleClose, handleReset, filter, handleSelectAll, admin } = this.props
    const { ifChecked } = this

    const values = {
      probability: [
        { label: 'Garantido', value: 'Garantido', subtitle: 'O nosso algoritmo detectou que a proposta do advogado do autor está abaixo da alçada. Agora é só você clicar em "aceitar"' }
      ],
      status: [
        { label: 'Em Análise', value: '1' },
        { label: 'Em Negociação', value: '2' },
        { label: 'Em Finalização', value: '3' },
        { label: 'Arquivados', value: '999' }
      ],
      subStatus: [
        { label: 'Com Sucesso', value: '1' },
        { label: 'Sem Sucesso', value: '2' },
        { label: 'Não Negociados', value: '3' },
      ],
      archiveReasons,
      archiving: [
        { label: 'Hoje', value: 'today' },
        { label: 'Ontem', value: 'yesterday' },
        { label: 'Esta Semana', value: 'thisWeek' },
        { label: 'Semana Passada', value: 'lastWeek' },
        { label: 'Este Mês', value: 'thisMonth' },
        { label: 'Mês Passado', value: 'lastMonth' },
        { label: 'Este Ano', value: 'thisYear' },
        { label: 'Ano Passado', value: 'lastYear' },
        { label: 'Últimos 30 Dias', value: 'last30days' },
        { label: 'Últimos 60 Dias', value: 'last60days' },
        { label: 'Últimos 90 Dias', value: 'last90days' }
      ],
      pending: [
        { label: '24 Horas', value: '24' },
        { label: '48 Horas', value: '48' },
        { label: '72 Horas', value: '72' }
      ],
      remainingTime: [
        { label: 'Em até 10 dias', value: 'next10Days' },
        { label: '11 a 20 dias', value: 'next20Days' },
        { label: '21 a 30 dias', value: 'next30Days' },
        { label: '31 a 40 dias', value: 'next40Days' }
      ],
      entries: [
        { label: 'Hoje', value: 'today' },
        { label: 'Ontem', value: 'yesterday' },
        { label: 'Esta Semana', value: 'thisWeek' },
        { label: 'Semana Passada', value: 'lastWeek' },
        { label: 'Este Mês', value: 'thisMonth' },
        { label: 'Mês Passado', value: 'lastMonth' },
        { label: 'Este Ano', value: 'thisYear' },
        { label: 'Ano Passado', value: 'lastYear' },
        { label: 'Últimos 30 Dias', value: 'last30days' },
        { label: 'Últimos 60 Dias', value: 'last60days' },
        { label: 'Últimos 90 Dias', value: 'last90days' }
      ],
      deadline: [
        { label: 'Expirado', value: 'expired' },
        { label: 'Hoje', value: 'today' },
        { label: 'Amanhã', value: 'tomorrow' },
        { label: 'Esta Semana', value: 'thisWeek' },
        { label: 'Próximos 15 dias', value: 'next15Days' },
        { label: 'Próximos 30 dias', value: 'next30Days' }
      ],
      companies,
      classifiers,
      lawFirms,
      createdBy,
      uf,
      origin: [
        { label: 'Pré Contencioso', value: '1' },
        { label: 'Contencioso', value: '2' }
      ]
    }

    return (
      <SideBar
        visible={visible}
        title="Filtros"
        button="Filtrar"
        handleOpen={handleOpen}
        handleClose={handleClose}>
        {!_.isEmpty(companies) && role === 'company' &&
          <MyCasesPageFilterSection
            type="radio"
            name="probability"
            title="Tags Inteligentes"
            beta
            options={values.probability}
            filter={filter}
            handleReset={() => handleReset('probability')} />
        }
        <MyCasesPageFilterSection
          type="checkbox"
          name="status"
          title="Status"
          options={values.status}
          filter={filter}
          handleReset={() => handleReset('status')}
          handleSelectAll={() => handleSelectAll('status', values.status.map(e => e.value))} />
        {ifChecked('status', '999', 'subStatus') &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="subStatus"
            title="Arquivado"
            options={values.subStatus}
            filter={filter}
            handleReset={() => handleReset('subStatus')}
            handleSelectAll={() => handleSelectAll('subStatus', values.subStatus.map(e => e.value))} />
        }
        {!_.isEmpty(archiveReasons) && role === 'company' && ifChecked('subStatus', '2', 'archiveReasons') &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="archiveReasons"
            title="Motivo do Arquivamento"
            options={values.archiveReasons}
            filter={filter}
            handleReset={() => handleReset('archiveReasons')}
            handleSelectAll={() => handleSelectAll('archiveReasons', values.archiveReasons.map(e => e.value))} />
        }
        {role === 'company' && (ifChecked('subStatus', '1', 'archiveReason') || ifChecked('subStatus', '2', 'archiveReason') || ifChecked('subStatus', '3', 'archiveReason')) &&
          <MyCasesPageFilterSection
            type="radio"
            name="archiving"
            title="Data do Arquivamento"
            options={values.archiving}
            filter={filter}
            handleReset={() => handleReset('period')} />
        }
        <MyCasesPageFilterSection
          type="checkbox"
          name="turn"
          title="Aguardando Resposta"
          options={role === 'lawyer' ?
            [{ label: 'Sua Resposta', value: '1' }, { label: 'Da Empresa', value: '2' }] :
            [{ label: 'Sua Resposta', value: '2' }, { label: 'Do Advogado', value: '1' }]
          }
          filter={filter}
          handleReset={() => handleReset('turn')}
          handleSelectAll={() => handleSelectAll('turn', ['1', '2'])} />
        {role === 'company' &&
          <MyCasesPageFilterSection
            type="radio"
            name="pending"
            title="Inativo há mais de"
            options={values.pending}
            filter={filter}
            handleReset={() => handleReset('pending')} />
        }
        {(role === 'company' && admin) &&
          <MyCasesPageFilterSection
            type="radio"
            name="remainingTime"
            title="Arquivamento automático"
            options={values.remainingTime}
            filter={filter}
            handleReset={() => handleReset('remainingTime')} />
        }
        {role === 'company' &&
          <MyCasesPageFilterSection
            type="radio"
            name="entries"
            title="Data da Inserção"
            options={values.entries}
            filter={filter}
            handleReset={() => handleReset('entries')} />
        }
        {role === 'company' &&
          <MyCasesPageFilterSection
            type="radio"
            name="deadline"
            title="Prazo de Encerramento"
            options={values.deadline}
            filter={filter}
            handleReset={() => handleReset('deadline')} />
        }
        {!_.isEmpty(companies) && role === 'company' &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="companies"
            title="Empresas"
            options={values.companies}
            sorted
            filter={filter}
            handleReset={() => handleReset('companies')}
            handleSelectAll={() => handleSelectAll('companies', values.companies.map(e => e.value))} />
        }
        {!_.isEmpty(classifiers) && role === 'company' &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="classifiers"
            title="Classificações"
            options={values.classifiers}
            filter={filter}
            handleReset={() => handleReset('classifiers')}
            handleSelectAll={() => handleSelectAll('classifiers', values.classifiers.map(e => e.value))} />
        }
        {!_.isEmpty(lawFirms) && role === 'company' &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="lawFirms"
            title="Escritórios"
            options={values.lawFirms}
            sorted
            filter={filter}
            handleReset={() => handleReset('lawFirms')}
            handleSelectAll={() => handleSelectAll('lawFirms', values.lawFirms.map(e => e.value))} />
        }
        {!_.isEmpty(createdBy) && role === 'company' &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="createdBy"
            title="Criado Por"
            options={values.createdBy}
            sorted
            filter={filter}
            handleReset={() => handleReset('createdBy')}
            handleSelectAll={() => handleSelectAll('createdBy', values.createdBy.map(e => e.value))} />
        }
        {role === 'company' &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="regions"
            title="Estado"
            options={values.uf}
            filter={filter}
            handleReset={() => handleReset('regions')}
            handleSelectAll={() => handleSelectAll('regions', values.uf.map(e => e.value))} />
        }
        {role === 'company' &&
          <MyCasesPageFilterSection
            type="checkbox"
            name="origin"
            title="Módulo"
            options={values.origin}
            filter={filter}
            handleReset={() => handleReset('origin')}
            handleSelectAll={() => handleSelectAll('origin', values.origin.map(e => e.value))} />
        }
      </SideBar>
    )
  }
}

MyCasesPageFilter = reduxForm({
  form: 'filter',
  destroyOnUnmount: false
})(MyCasesPageFilter)

const selector = formValueSelector('filter')

export default MyCasesPageFilter
